
import React from 'react';
import Layout from '@/components/layout/Layout';
import HeroSection from '@/components/home/HeroSection';
import WhatWeDoSection from '@/components/home/WhatWeDoSection';
import WhoWeHelpSection from '@/components/home/WhoWeHelpSection';
import WhyNowSection from '@/components/home/WhyNowSection';
import VisionSection from '@/components/home/VisionSection';
import CTASection from '@/components/home/CTASection';
import ContactSection from '@/components/home/ContactSection';

const Index = () => {
  return (
    <Layout>
      <HeroSection />
      <WhatWeDoSection />
      <WhoWeHelpSection />
      <WhyNowSection />
      <VisionSection />
      <CTASection />
      <ContactSection />
    </Layout>
  );
};

export default Index;
